/**
 * PageViewTracker component
 * Fires Meta PageView events on route changes (including initial page load)
 * 
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageViewWithCapi } from '../../utils/metaPixel';
const PageViewTracker = () => {
  const {
    pathname
  } = useLocation();
  const previousPathRef = useRef(null);
  useEffect(() => {
    if (previousPathRef.current === pathname) {
      return;
    }
    trackPageViewWithCapi();
    previousPathRef.current = pathname;
  }, [pathname]);
  return null;
};
export default PageViewTracker;